import {useContext} from 'react'
import camelcaseKeys from 'camelcase-keys'

import AppContext from 'components/app/AppContext'

// Hook to return a string translation lookup function.
// You include the hook in your component and it returns a method _t("key") which returns the translated text
// Usage: import { useTextLookup } from 'utils/text'
// const _t = useTextLookup()
// <SomeComponent>{_t("key")}</SomeComponent>
//
export const useTextLookup = () => {
    const appContext = useContext(AppContext)

    return (key: string) => {
        const text = appContext.text[key]
        if (text != null) {
            return camelcaseKeys(text, { deep: true }).content
        }

        return "" //`["${key}" not found]`
    }   
}
